import formatMoney from '../../core/formatMoney';
import { handleize, escapeHtml } from '../../core/helpers';
import { getSizedImageURL } from '../../core/images';
import getProductURL from '../../core/productURL';

const CONSTANTS = {
  MONEY_FORMAT: theme.moneyFormat,
  DEFAULT_ALT_TEXT: {
    FRONT: 'Front of',
    BACK: 'Back of',
    WITH_COLOR: 'with color',
  }
};

/* Different promo message for logged-in/loyalty and guest customers
   Also update components/quicklook.js and snippets/product-details.liquid
 */
const promoForTile = (product, tile_settings, product_tags) => {
  const is_loyalty_member = (typeof window.theme.customer.id !== 'undefined');
  let final_promo_html = '';

  /**************************************/
  /************ Build Values ************/
  /**************************************/

  // Promo applied by product tag or collection. Ignored when a promotion call out message has been defined for all products
  let promo_message = window.theme.promoMessage.guests;
  let promo_message_color = window.theme.promoMessage.color;
  let promo_discount = window.theme.promoMessage.guestPercentOff;
  let promo_discount_color = window.theme.promoMessage.colorPercentOff;
  let promo_tag = window.theme.promoMessage.tag;
  let promo_collection = window.theme.promoMessage.collection;

  // Variables for 2nd tag support
  let promo_message_2 = window.theme.promoMessage.guests2;
  const promo_message_color_2 = window.theme.promoMessage.color2;
  let promo_discount_2 = window.theme.promoMessage.guestPercentOff2;
  let promo_discount_color_2 = window.theme.promoMessage.colorPercentOff2;
  let promo_tag_2 = window.theme.promoMessage.tag2;

  // let special_message = '';

  // Promo applied to all products.
  if (window.theme.promoMessage.guestsAllProducts !== '') {
    promo_message = window.theme.promoMessage.guestsAllProducts;
    promo_message_color = window.theme.promoMessage.colorAllProducts;
  }

  if (window.theme.promoMessage.guestAllProductsPercentOff !== 0) {
    promo_discount = window.theme.promoMessage.guestAllProductsPercentOff;
    promo_discount_color = window.theme.promoMessage.colorAllProductsPercentOff;
  }

  if (window.theme.promoMessage.guestsAllProducts !== '' || window.theme.promoMessage.guestAllProductsPercentOff !== 0) {
    promo_tag = '';
    promo_collection = '';
    promo_tag_2 = '';
  }

  // Promo applied to loyalty members
  if (is_loyalty_member) {
    promo_message = window.theme.promoMessage.loyalty;
    promo_discount = window.theme.promoMessage.loyaltyPercentOff;
    promo_discount_color = window.theme.promoMessage.colorPercentOff;

    promo_message_2 = window.theme.promoMessage.loyalty2;
    promo_discount_2 = window.theme.promoMessage.loyaltyPercentOff2;
    promo_discount_color_2 = window.theme.promoMessage.colorPercentOff2;

    // Promo applied to all products.
    if (window.theme.promoMessage.loyaltyAllProducts !== '') {
      promo_message = window.theme.promoMessage.loyaltyAllProducts;
      promo_message_color = window.theme.promoMessage.colorAllProducts;
    }

    if (window.theme.promoMessage.loyaltyAllProductsPercentOff !== 0) {
      promo_discount = window.theme.promoMessage.loyaltyAllProductsPercentOff;
      promo_discount_color = window.theme.promoMessage.colorAllProductsPercentOff;
    }

    if (window.theme.promoMessage.loyaltyAllProducts !== '' || window.theme.promoMessage.loyaltyAllProductsPercentOff !== 0) {
      promo_tag = '';
      promo_collection = '';
      promo_tag_2 = '';
    }
  }

  /*
  // Special message
  if (window.theme.promoMessage.specialMessage !== '') {
    if (is_loyalty_member) {
      if (window.theme.promoMessage.specialMessageCustomers === 'guests' || window.theme.promoMessage.specialMessageCustomers === 'all') {
        special_message = window.theme.promoMessage.specialMessage;
      }
    } else if (window.theme.promoMessage.specialMessageCustomers === 'members' || window.theme.promoMessage.specialMessageCustomers === 'all') {
      special_message = window.theme.promoMessage.specialMessage;
    }
  }

  special_message = special_message;
  */

  promo_message = promo_message;
  promo_message_2 = promo_message_2;

  const before_price_text = (window.theme.promoMessage.promoBeforeText) ? `${window.theme.promoMessage.promoBeforeText} ` : '';
  const between_price_text = (window.theme.promoMessage.promoBetweenText) ? ` ${window.theme.promoMessage.promoBetweenText} ` : '';
  const after_price_text = (window.theme.promoMessage.promoAfterText) ? ` ${window.theme.promoMessage.promoAfterText}` : '';

  /**************************************/
  /************* Build HTML *************/
  /**************************************/
  // Discount message
  let discount_message_html = '';
  if (promo_discount && promo_discount !== 0 && (product.from === '' || typeof product.from === 'undefined')) {
    discount_message_html = `<p class="product-tile__price-promo" data-product-tile-price-promo data-raw-price="${product.price.toFixed(2)}" data-promo-discount="${promo_discount}"><span class="price__promo" style="color: ${promo_discount_color} !important;">${before_price_text}${formatMoney(String((product.price - ((product.price * promo_discount) / 100)).toFixed(2)), CONSTANTS.MONEY_FORMAT )}${between_price_text}${promo_discount}%${after_price_text}</span></p>`;
  }

  let discount_message_html_2 = '';
  if (promo_discount_2 && promo_discount_2 !== 0 && (product.from === '' || typeof product.from === 'undefined')) {
    discount_message_html_2 = `<p class="product-tile__price-promo" data-product-tile-price-promo data-raw-price="${product.price.toFixed(2)}" data-promo-discount="${promo_discount_2}"><span class="price__promo" style="color: ${promo_discount_color_2} !important;">${before_price_text}${formatMoney(String((product.price - ((product.price * promo_discount_2) / 100)).toFixed(2)), CONSTANTS.MONEY_FORMAT )}${between_price_text}${promo_discount_2}%${after_price_text}</span></p>`;
  }

  // Special message, we need to make sure it only applies to the selected collection if any
  const special_message_html = '';
  /*
  if (special_message !== '') {
    let show_special_message = false;

    if (window.theme.promoMessage.specialMessageCollection === '') {
      show_special_message = true;
    } else {
      if (tile_settings.is_search === false && document.querySelector('[data-collection-grid]') !== null) {
        if (window.theme.promoMessage.specialMessageCollection === document.querySelector('[data-collection-grid]').dataset.collection) {
          show_special_message = true;
        }
      }

      if (show_special_message === false && typeof product.categories !== 'undefined' && product.categories.length > 0) {
        for (let i = 0; i < product.categories.length; i++) {
          const collection = handleize(product.categories[i]);

          if (collection === window.theme.promoMessage.specialMessageCollection) {
            show_special_message = true;
            break;
          }
        }
      }
    }

    // console.log('show_special_message', show_special_message);
    if (show_special_message === true) {
      special_message_html = `<span class="product-tile__special-message" data-same-line="${window.theme.promoMessage.specialMessageSameLine}">${special_message}</span>`;
    }
  }
  */

  // Promo message
  let promo_message_html = '';
  if (promo_message !== '') {
    promo_message_html = `<p data-product-tile-message class="product-tile__message" style="color: ${promo_message_color} !important;" tabindex="0" data-tag="1"><span>${promo_message}</span>${special_message_html}</p>`;
  }

  let promo_message_html_2 = '';
  if (promo_message_2 !== '') {
    promo_message_html_2 = `<p data-product-tile-message class="product-tile__message" style="color: ${promo_message_color_2} !important;" tabindex="0" data-tag="2"><span>${promo_message_2}</span>${special_message_html}</p>`;
  }

  if (promo_tag === '' && promo_collection === '') {
    // Message for all products
    final_promo_html += discount_message_html;
    final_promo_html += promo_message_html;

    if (promo_message_html === '' && special_message_html !== '') {
      final_promo_html += `<p data-product-tile-message class="product-tile__message" style="color: ${promo_message_color} !important;" tabindex="0">${special_message_html}</p>`;
    }
  } else {
    // Message for specific tagged products or collections
    let show_promo_message = false;
    let show_promo_message_2 = false;

    if (promo_collection === '') {
      if (promo_tag !== '' || promo_tag_2 !== '') {
        for (let i = 0; i < product_tags.length; i++) {
          const tag = product_tags[i];

          if (promo_tag !== '') {
            if (tag.indexOf(promo_tag) !== -1) {
              show_promo_message = true;
              break;
            }
          }

          if (promo_tag_2 !== '') {
            if (tag.indexOf(promo_tag_2) !== -1) {
              show_promo_message_2 = true;
              break;
            }
          }
        }
      }
    } else {
      if (tile_settings.is_search === false && document.querySelector('[data-collection-grid]') !== null) {
        if (promo_collection === document.querySelector('[data-collection-grid]').dataset.collection) {
          show_promo_message = true;
        }
      }

      if (show_promo_message === false && typeof product.categories !== 'undefined' && product.categories.length > 0) {
        for (let i = 0; i < product.categories.length; i++) {
          const collection = handleize(product.categories[i]);

          if (collection === promo_collection) {
            show_promo_message = true;
            break;
          }
        }
      }

      // Case where promo 1 collection is set and promo 2 tag is set; promo 2 takes over
      if (promo_tag_2 !== '') {
        for (let i = 0; i < product_tags.length; i++) {
          const tag = product_tags[i];

          if (tag.indexOf(promo_tag_2) !== -1) {
            show_promo_message = false;
            show_promo_message_2 = true;
            break;
          }
        }
      }
    }
    
    // console.log('show_promo_message', product, show_promo_message);
    if (show_promo_message === true) {
      final_promo_html += discount_message_html;
      final_promo_html += promo_message_html;

      if (promo_message_html === '' && special_message_html !== '') {
        final_promo_html += `<p data-product-tile-message class="product-tile__message" style="color: ${promo_message_color} !important;" tabindex="0">${special_message_html}</p>`;
      }
    } else if (show_promo_message_2 === true) {
      final_promo_html += discount_message_html_2;
      final_promo_html += promo_message_html_2;

      if (promo_message_html_2 === '' && special_message_html !== '') {
        final_promo_html += `<p data-product-tile-message class="product-tile__message" style="color: ${promo_message_color_2} !important;" tabindex="0">${special_message_html}</p>`;
      }
    } else if (special_message_html !== '') {
      final_promo_html += `<p data-product-tile-message class="product-tile__message" style="color:${promo_message_color} !important;" tabindex="0">${special_message_html}</p>`;
    }
  }

  return final_promo_html;
};

const featuredPromoForTile = (product, tile_settings, product_tags) => {
  let final_promo_html = '';
  const is_loyalty_member = (typeof window.theme.customer.id !== 'undefined');
  const promo_tag = window.theme.promoMessage.tagTilesOnly;
  const promo_collection = window.theme.promoMessage.collectionTilesOnly;
  const promo_message = (is_loyalty_member) ? window.theme.promoMessage.loyaltyMessageTilesOnly : window.theme.promoMessage.guestMessageTilesOnly;
  const promo_link = (is_loyalty_member) ? window.theme.promoMessage.loyaltyLinkTilesOnly : window.theme.promoMessage.guestLinkTilesOnly;

  if (promo_message === '' || (promo_tag === '' && promo_collection === '')) {
    return final_promo_html;
  }

  let show_promo_message = false;

  if (promo_collection === '') {
    if (promo_tag !== '') {
      for (let i = 0; i < product_tags.length; i++) {
        const tag = product_tags[i];

        if (promo_tag !== '') {
          if (tag.indexOf(promo_tag) !== -1) {
            show_promo_message = true;
            break;
          }
        }
      }
    }
  } else {
    if (tile_settings.is_search === false && document.querySelector('[data-collection-grid]') !== null) {
      if (promo_collection === document.querySelector('[data-collection-grid]').dataset.collection) {
        show_promo_message = true;
      }
    }

    if (show_promo_message === false && typeof product.categories !== 'undefined' && product.categories.length > 0) {
      for (let i = 0; i < product.categories.length; i++) {
        const collection = handleize(product.categories[i]);

        if (collection === promo_collection) {
          show_promo_message = true;
          break;
        }
      }
    }
  }

  if (show_promo_message === true) {
    if (promo_link === '') {
      final_promo_html = `<div class="product-tile__featured-promo" tabindex="0" data-product-tile-featured-message>${promo_message}</div>`;
    } else {
      final_promo_html = `<div class="product-tile__featured-promo" tabindex="0" data-product-tile-featured-message><a href="${promo_link}">${promo_message}</a></div>`;
    }
  }

  return final_promo_html;
};

/*
  Flags based on tags.
  Limit 1 per tile.
  Priority: Best Seller app flag > Trending app flag > Style metafield flag > Tag-based flag
*/
const flagsForTile = (product, product_tags) => {
  let html = '';

  // Flags based on metafields
  let has_flag = false;
  if (typeof product.custom_fields !== 'undefined') {
    if (typeof product?.custom_fields?.bestseller_style_30 !== 'undefined' && parseInt(product?.custom_fields?.bestseller_style_30) <= 30) {
      html += `<div class="product-tile__flag product-tile__flag--app">Best Seller</div>`;
      has_flag = true;
    }

    if (typeof product?.custom_fields?.bestseller_style_14 !== 'undefined' && parseInt(product?.custom_fields?.bestseller_style_14) <= 30) {
      html += `<div class="product-tile__flag product-tile__flag--app">Trending</div>`;
      has_flag = true;
    }
  }

  // Tag-based flag
  // We don't show the final sale tags anymore, but they are needed to add a cart note
  if (has_flag === false) {
    product_tags.forEach((tag) => {
      if (tag.indexOf('flag:') !== -1 && has_flag === false) {
        html += `<div class="product-tile__flag${(tag.toLowerCase().includes('final sale')) ? ' product-tile__flag--final' : ' product-tile__flag--tag'}">${tag.replace('flag:', '')}</div>`;
        has_flag = !(tag.toLowerCase().includes('final sale'));
      }
    });
  }

  return `<div class="product-tile__flags">${html}</div>`;
};

const wishlistForTile = (product, product_handle) => {
  const is_loyalty_member = (typeof window.theme.customer.id !== 'undefined');

  return (!is_loyalty_member) ? `<button type="button" class="swym-button swym-add-to-wishlist-view-product product_${product.product_id} swym-heart swym-loaded" data-product-swym-wishlist data-product-handle="${product_handle}" data-open-signin-actions-modal="wishlist" aria-label="Add to Wishlist"></button>` : `<button data-with-epi="true" type="button" class="swym-button swym-add-to-wishlist-view-product product_${product.product_id}" data-product-swym-wishlist data-swaction="addToWishlist" data-product-id="${product.product_id}" data-variant-id="${product.skus[0].id}" data-product-url="${product.url}" data-product-handle="${product_handle}" aria-label="Add to Wishlist"></button>`;
};

const imagesForTile = (product, safe_product_title, tile_settings) => {
  const placeholder = window.theme.collections.placeholder;

  // Don't lazy load the product images above the fold
  const loading_type = (typeof tile_settings.tile_index !== 'undefined' && tile_settings.tile_index !== '' && tile_settings.tile_index <= 5) ? 'eager' : 'lazy';

  let images_html = `<div class="product-tile__image--placeholder"><img src="${placeholder}" alt="${safe_product_title}" width="300" height="460" /></div>`;

  if ((typeof product.swatches !== 'undefined' && product.swatches.length) || typeof product.image_url === 'undefined') {
    images_html += `<div class="product-tile__image--main" data-product-main-image><img loading="${loading_type}" src="${placeholder}" alt="${safe_product_title}" width="300" height="460" /></div>`;

    if (window.theme.breakpoints.current !== 'mobile') {
      images_html += `<div class="product-tile__image--alt" data-product-alt-image><img loading="lazy" src="${placeholder}" alt="${safe_product_title}" width="300" height="460" /></div>`;
    }
  } else if (window.theme.breakpoints.current === 'mobile') {
    // images_html += `<div class="product-tile__image--main" data-product-main-image><img loading="lazy" src="${product.image_url}" width="${product.image_width}" alt="${safe_product_title}" onError="this.src = '${placeholder}';" /></div>`;

    // IMPORTANT: Don't forget to update the image within selectNewColor.js
    // Note, we don't generate the images to save on rendering time when the swatches are present since they'll be generated from selectNewColor.js

    // We have 2 slides on mobile (use 100vw for double size)
    // We have 5 slides on desktop (use 40vw for double size)

    if (tile_settings.has_swatches && !tile_settings.is_simplified) {
      images_html += `
        <div class="product-tile__image--main" data-product-main-image></div>
      `;
    } else {
      images_html += `
        <div class="product-tile__image--main" data-product-main-image>
          <img
            loading="${loading_type}"
            src="${getSizedImageURL(product.image_url, '600x')}"
            srcset="
              ${getSizedImageURL(product.image_url, '90x138')} 90w,
              ${getSizedImageURL(product.image_url, '180x276')} 180w,
              ${getSizedImageURL(product.image_url, '250x383')} 250w,
              ${getSizedImageURL(product.image_url, '400x613')} 400w,
              ${getSizedImageURL(product.image_url, '450x690')} 450w,
              ${getSizedImageURL(product.image_url, '500x767')} 500w,
              ${getSizedImageURL(product.image_url, '700x1073')} 700w,
              ${getSizedImageURL(product.image_url, '800x1200')} 800w
            "
            alt="${safe_product_title}"
            sizes="(max-width: 768px) 100vw, 40vw"
            width="180" height="276"
            data-original-src="${product.image_url}"
            onError="this.onerror=null; this.src='${placeholder}'; this.srcset='';"
          />
        </div>
      `;
    }
  } else if (window.theme.breakpoints.current !== 'mobile') {
    if (tile_settings.has_swatches && !tile_settings.is_simplified) {
      images_html += `
        <div class="product-tile__image--main" data-product-main-image></div>
      `;
    } else {
      images_html += `
        <div class="product-tile__image--main" data-product-main-image>
          <img
            loading="${loading_type}"
            src="${getSizedImageURL(product.image_url, '400x613')}"
            srcset="
              ${getSizedImageURL(product.image_url, '400x613')} 400w,
              ${getSizedImageURL(product.image_url, '450x690')} 450w,
              ${getSizedImageURL(product.image_url, '500x767')} 500w,
              ${getSizedImageURL(product.image_url, '600x915')} 600w,
            "
            sizes="276px"
            alt="${safe_product_title}"
            width="400" height="613"
            data-original-src="${product.image_url}"
            data-new-color-selected="false"
            onError="this.onerror=null; this.src='${placeholder}'; this.srcset='';"
          />
        </div>
      `;
    }

    // images_html += `<div class="product-tile__image--alt" data-product-alt-image><img loading="lazy" src="${product.image_url}" width="${product.image_width}" alt="${safe_product_title}" onError="this.src = '${placeholder}';" /></div>`;

    // We have 2 slides on mobile (use 100vw for double size)
    // We have 5 slides on desktop (use 40vw for double size)
    if (tile_settings.has_swatches) {
      images_html += `
        <div class="product-tile__image--alt" data-product-alt-image></div>
      `;
    } else {
      images_html += `
        <div class="product-tile__image--alt" data-product-alt-image>
          <img
            loading="lazy"
            src="${getSizedImageURL(product.image_url, '400x613')}"
            srcset="
              ${getSizedImageURL(product.image_url, '400x613')} 400w,
              ${getSizedImageURL(product.image_url, '450x690')} 450w,
              ${getSizedImageURL(product.image_url, '500x767')} 500w,
              ${getSizedImageURL(product.image_url, '600x915')} 600w,
            "
            sizes="276px"
            alt="${safe_product_title}"
            width="400" height="613"
            data-original-src="${product.image_url}"
            onError="this.onerror=null; this.src='${placeholder}'; this.srcset='';"
          />
        </div>
      `;
    }
  }

  if (tile_settings.is_simplified === true && tile_settings.has_quickview === false) {
    images_html += `<div class="product-tile__shop">SHOP NOW</div>`;
  }

  return images_html;
};

// Disabled, functionality might not be working if re-enabled
const addToCartAltForTile = (product) => {
  return '';

  // return `<div class="add-to-cart-alt add-to-cart-alt--desktop btn btn--primary<% if (!product.available) { %> unavailable<% } %>" data-add-to-cart-alt-button role="button" tabindex="0" aria-label="Show product options"><span><%= window.theme.strings.addToCart %></span></div><div class="add-to-cart-alt add-to-cart-alt--mobile<% if (!product.available) { %> unavailable<% } %>" data-add-to-cart-alt-button><span><%= window.theme.strings.addToCart %></span></div>`;
};

const quickviewForTile = () => {
  return `<div class="quicklook__button btn btn--secondary hidden--mobile" data-quicklook-button data-modal="#quicklook-modal"><span>${window.theme.strings.quickView}</span></div><div class="quicklook__button--mobile" data-quicklook-button-mobile><span>${window.theme.strings.quickView}</span></div>`;
};

// This is a fallback function; On PLPs, Nosto returns the recommended variant first, which is not always the first variant in the list and might not return the correct back image
const findBackVariantImage = (product, color_handle) => {
  try {
    let variant_back_image = '';

    // Find the next variant with a different color
    let found_same_color = false;
    for (let i = 0; i < product.skus.length; i++) {
      const find_variant = product.skus[i];
      const find_color_value = find_variant.custom_fields.Color;
      const find_color_handle = handleize(find_color_value);

      if (find_color_handle === color_handle) {
        found_same_color = true;
        continue;
      } else if (found_same_color && variant_back_image === '') {
        const next_variant_with_different_color = product.skus[i];
        const next_front_image = next_variant_with_different_color.image_url;
        const next_front_image_index = product.skus.findIndex(sku => sku.image_url === next_front_image);

        if (next_front_image_index > 0 && typeof product.alternate_image_urls[next_front_image_index - 1] !== 'undefined') {
          variant_back_image = product.alternate_image_urls[next_front_image_index - 1];
        } else if (typeof product.alternate_image_urls === 'undefined') {
          console.log('No alternate image URLs found for product:', product.name);
        }
        
        found_same_color = false;
        break;
      }
    }

    // console.log(product.name, color_handle, variant_back_image);

    // Last color variant
    if (found_same_color && variant_back_image === '') {
      variant_back_image = product.alternate_image_urls[product.alternate_image_urls.length - 1];
    }

    return variant_back_image;
  } catch (error) {
    console.error('Error finding back variant image:', error);
    return '';
  }
};

const swatchesForTile = (product, tile_settings) => {
  // Swatches metafield format
  // [
  //   {
  //       "color_name": "Black",
  //       "color_handle": "black",
  //       "swatch_value": "#0e0e0e",
  //       "swatch_type": "hex"
  //   },
  //   {
  //       "color_name": "Moss",
  //       "color_handle": "moss",
  //       "swatch_value": "https://cdn.shopify.com/s/files/1/2483/6632/t/75/assets/astr-swatch--moss-4bdb0f3e-2c14-4ca0-976c-3f1dc07850d6.png?v=1726505940",
  //       "swatch_type": "image"
  //   }
  // ]

  let swatches_json = [];
  if (typeof product.custom_fields !== 'undefined' && typeof product.custom_fields['astr-swatches'] !== 'undefined') {
    swatches_json = (typeof product.custom_fields['astr-swatches'] === 'string') ? JSON.parse(product.custom_fields['astr-swatches']) : product.custom_fields['astr-swatches'];
  }

  let images_details = [];
  if (typeof product?.custom_fields['astr-images_details'] !== 'undefined') {
    images_details = (typeof product.custom_fields['astr-images_details'] === 'string') ? JSON.parse(product.custom_fields['astr-images_details']) : product.custom_fields['astr-images_details'];
  }
  
  const product_color_names = product.skus
    .map((sku) => sku.custom_fields && sku.custom_fields.Color)
    .filter(Boolean);
  if (product_color_names.length === 0) {
    console.error('[ASTR] This product has no colors defined:', product);
  }
  let unique_product_color_names = [...new Set(product_color_names)];
  const is_search = document.querySelector('body').classList.contains('has-overlay-search');

  // We need to hide the non-plus size swatches if we are on a plus size PLP or it's search results (unless there are no plus sizes available)
  // Example: https://www.astrthelabel.com/collections/plus-size-dresses
  if (document.querySelector('.main-collection [data-collection-grid]')?.dataset?.plus === 'true') {
    const unique_product_color_names_plus_sizes = [];
    unique_product_color_names.forEach((color_name) => {
      const color_value = product.skus.find((sku) => sku.custom_fields.Color === color_name);
      if (color_value.name.includes('Plus Size -')) {
        unique_product_color_names_plus_sizes.push(color_name);
      }
    });

    if (is_search) {
      unique_product_color_names = (unique_product_color_names_plus_sizes.length === 0) ? unique_product_color_names : unique_product_color_names_plus_sizes;
    } else {
      unique_product_color_names = unique_product_color_names_plus_sizes;
    }
  }

  // Remove plus size colors if we are not on a plus size PLP, unless there are no standard sizes available;
  if (document.querySelector('.main-collection [data-collection-grid]') === null || document.querySelector('.main-collection [data-collection-grid]')?.dataset?.plus === 'false') {
    const unique_product_color_names_standard_sizes = [];
    unique_product_color_names.forEach((color_name) => {
      const color_value = product.skus.find((sku) => sku.custom_fields.Color === color_name);
      if (!color_value.name.includes('Plus Size -')) {
        unique_product_color_names_standard_sizes.push(color_name);
      }
    });

    if (is_search) {
      unique_product_color_names = (unique_product_color_names_standard_sizes.length === 0) ? unique_product_color_names : unique_product_color_names_standard_sizes;
    } else {
      unique_product_color_names = unique_product_color_names_standard_sizes;
    }
  }

  const unique_product_color_handles = unique_product_color_names.map((color) => handleize(color));

  // We don't show products that have no swatches available
  if (unique_product_color_handles.length === 0) {
    return '';
  }

  // Nosto sometimes returns "recommended_sku" for recommendations only (Not collections or search results), we'll use it to init the correct color swatch
  let recommended_color = '';
  if (typeof product.recommended_sku !== 'undefined') {
    recommended_color = product.recommended_sku.name.split(' / ')[0];
  }

  let swatch_items_html = '';
  let total_swatches = 0;
  unique_product_color_names.forEach((color, index) => {
    const color_handle = unique_product_color_handles[index];

    // Find the 1st variant using this color
    const same_color_variants = product.skus.filter((sku) => sku.custom_fields.Color === color);
    const first_variant = same_color_variants[0];

    // Extract the images data from the metafield
    let front_image_url = '';
    let front_image_alt = '';
    let back_image_url = '';
    let back_image_alt = '';

    images_details.find((image) => {
      if (image.color_name === color) {
        front_image_url = first_variant.image_url;
        front_image_alt = (image.front_image_alt === '') ? `${CONSTANTS.DEFAULT_ALT_TEXT.FRONT} ${product.name} ${CONSTANTS.DEFAULT_ALT_TEXT.WITH_COLOR} ${color}` : image.front_image_alt;
        back_image_url = (image.back_image_url === '') ? findBackVariantImage(product, color_handle) : image.back_image_url;
        back_image_alt = (image.back_image_alt === '') ? `${CONSTANTS.DEFAULT_ALT_TEXT.BACK} ${product.name} ${CONSTANTS.DEFAULT_ALT_TEXT.WITH_COLOR} ${color}` : image.back_image_alt;
      }
    });

    // Case where we use special ecom images https://astrthelabel.atlassian.net/browse/ASTR-864
    // For AB testing purposes only
    // Last image becomes the 1st one and the 1st one becomes the last one for hover
    const hasEcomImage = product.skus.some(
      sku => sku.custom_fields && sku.custom_fields['astr-use_ecom_image'] === 'true'
    );

    if (document.querySelector('.main-collection-section--settings')?.dataset.abTesting === 'b' && hasEcomImage) {
      const front_image_url_save = front_image_url;
      const front_image_alt_save = front_image_alt;
      front_image_url = back_image_url;
      front_image_alt = back_image_alt;
      back_image_url = front_image_url_save;
      back_image_alt = front_image_alt_save;
    }

    // Find color fill
    let swatch_json = swatches_json.find((swatch) => swatch.color_handle === color_handle);
    if (typeof swatch_json === 'undefined' && color_handle.includes('plus-size-')) {
      swatch_json = swatches_json.find((swatch) => swatch.color_handle === color_handle.replace('plus-size-', ''));
    }

    // Don't lazy load the product images above the fold
    const loading_type = (typeof tile_settings.tile_index !== 'undefined' && tile_settings.tile_index !== '' && tile_settings.tile_index <= 5) ? 'eager' : 'lazy';

    let swatch_span = `<span style="background-color: #FFFFFF;"></span>`;
    if (typeof swatch_json !== 'undefined') {
      if (swatch_json.swatch_type === 'image') {
        const swatch_img_base = escapeHtml(swatch_json.swatch_value);
        swatch_span = `<span>
          <img
            loading="${loading_type}"
            src="${swatch_img_base.replace(/(\.[a-z]+)$/, '_15x15$1')}"
            srcset="
              ${swatch_img_base.replace(/(\.[a-z]+)$/, '_15x15$1')} 15w,
              ${swatch_img_base.replace(/(\.[a-z]+)$/, '_30x30$1')} 30w,
              ${swatch_img_base.replace(/(\.[a-z]+)$/, '_60x60$1')} 60w
            "
            sizes="15px"
            alt="${escapeHtml(color)} color swatch"
            width="15"
            height="15"
            style="max-width:100%;height:auto"
          />
        </span>`;
      } else {
        swatch_span = `<span style="background-color: ${escapeHtml(swatch_json.swatch_value)};"></span>`;
      }
    }

    swatch_items_html += `
      <div
        data-color-swatch
        class="color-swatch"
        role="button"
        aria-label="Select ${escapeHtml(color)} color"
        tabindex="0"
        data-variant-id="${first_variant.id}"
        data-color-value="${escapeHtml(color)}"
        data-color-handle="${color_handle}"
        data-front="${front_image_url}"
        data-back="${back_image_url}"
        data-front-alt="${front_image_alt}"
        data-back-alt="${back_image_alt}"
        data-is-recommended="${(color === recommended_color) ? 'true' : 'false'}"
      >
        ${swatch_span}
      </div>`;

    total_swatches++;
  });

  const swatches_html = `
    <div class="product-tile__colors" data-product-tile-colors>
      <div class="color-swatches" data-color-swatches>
        ${swatch_items_html}
      </div>
      <a href="${product.url}" aria-label="More Colors +" tabindex="0" class="color-swatch__more" data-total-swatches="${total_swatches}"><span>More Colors +</span></a>
    </div>
  `;

  return swatches_html;
};

const ratingsForTile = (product) => {
  /*
  // Find out if one of the skus has the stamped.reviews_average metafield available and get the 1st one available
  let ratings_html = '';
  let reviews_average = null;

  for (let i = 0; i < product.skus.length; i++) {
    const sku = product.skus[i];

    if (typeof sku.custom_fields['stamped-reviews_average'] !== 'undefined' && sku.custom_fields['stamped-reviews_average'] !== null && sku.custom_fields['stamped-reviews_average'] !== '') {
      reviews_average = sku.custom_fields['stamped-reviews_average'];
      break;
    }
  }
  */
  // Rating is now provided at product level with Nosto
  let reviews_average = null;

  if (typeof product?.custom_fields !== 'undefined' && typeof product?.custom_fields['stamped-reviews_average'] !== 'undefined' && product?.custom_fields['stamped-reviews_average'] !== null && product?.custom_fields['stamped-reviews_average'] !== '') {
    reviews_average = product?.custom_fields['stamped-reviews_average'];
    
    if (reviews_average === '0' || reviews_average === '0.0' || reviews_average === '0.00') {
      reviews_average = null;
    }
  }

  return reviews_average
    ? `<a
        href="${product.url}#stamped-main-widget"
        class="product-tile__rating"
        data-product-tile-rating
        aria-label="Product rating ${Number(reviews_average).toFixed(1)} out of 5"
      >
          <svg aria-hidden="true" aria-label="Rating icon" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.6842 10.1897L10.5874 12.5454L9.55157 8.10544L13 5.11807L8.45894 4.73281L6.6842 0.545441L4.90946 4.73281L0.368408 5.11807L3.81683 8.10544L2.78104 12.5454L6.6842 10.1897Z" fill="black" />
          </svg>
          <span>${Number(reviews_average).toFixed(1)}</span>
      </a>` : '';
};

const pricesForTile = (product, product_available, tile_settings) => {
  let list_price = product.list_price;
  let price = product.price;

  // If we have a sale price at variant level, we use it
  let lowest_price = 0;
  let highest_price = 0;

  product.skus.forEach((sku) => {
    lowest_price = (lowest_price === 0 || sku.price < lowest_price) ? sku.price : lowest_price;
    highest_price = (highest_price === 0 || sku.price > highest_price) ? sku.price : highest_price;
  });

  // We requests prices from Nosto in USD as the currencies in Nosto and Shopify might not be fully synced
  if (window.theme.currency_cart !== 'USD' && tile_settings.enable_price_conversion === true) {
    const rate = Number(window.Shopify.currency.rate);
    lowest_price = lowest_price * rate;
    highest_price = highest_price * rate;
    list_price = list_price * rate;
    price = price * rate;
  }

  const from_price = (highest_price > lowest_price) ? String(parseFloat(lowest_price * 100, 10)) : '';

  let price_html = '';
  if (from_price === '') {
    if (list_price > price) {
      price_html += `<span class="visually-hidden">Regular price</span>
        <span class="price__sales">
          <s class="price__compare-at">${formatMoney(Number(list_price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</s>
          <span class="price__regular">${formatMoney(Number(price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>
        </span>`;
    } else {
      price_html += `<span class="price__regular">${formatMoney(Number(price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>`;
    }
  } else {
    price_html += `<span class="price__regular">From ${formatMoney(Number(from_price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>`;
  }

  if (!product_available) {
    price_html += `<span class="price__sold-out">Sold Out</span>`;
  }

  return price_html;
};

// tile_settings: {is_slider: true, is_simplified: true, has_swatches: false, has_quickview: false, is_search: false, is_lookbook: false, enable_price_conversion: false}
    // Simplified tiles don't have the wishlist, flags, reviews, promo messages...
    // Lookbook tiles use a different grid layout
    // Quickview: tiles need to have the swatches
export default (product, tile_settings, debug = false) => {
  try {
    if (typeof product === 'undefined') {
      console.log(`[ASTR] Product is missing`);
    }

    if (debug) {
      console.log(product);
    }

    if (typeof product.skus === 'undefined' || product.skus.length === 0) {
      console.log(`[ASTR] Product (id: ${product.product_id}) has no variants`);
      return;
    }

    let style = '';
    const product_handle = product.url.split('/').pop();
    const safe_product_title = product_handle.replace(/-/g, ' ');
    const product_url = getProductURL(product_handle);
    const product_available = true;
    const has_plus_size = product.skus.some(sku => sku.name.includes('Plus Size -'));
    const product_tags = [...product.tags1 ?? [], ...product.tags2 ?? [], ...product.tags3 ?? []];
    const promos_html = (tile_settings.is_simplified === true) ? '' : promoForTile(product, tile_settings, product_tags);
    const featured_promos_html = (tile_settings.is_simplified === true) ? '' : featuredPromoForTile(product, tile_settings, product_tags);
    const flags_html = (tile_settings.is_simplified === true) ? '' : flagsForTile(product, product_tags);
    const wishlist_html = (tile_settings.is_simplified === true) ? '' : wishlistForTile(product, product_handle);
    const images_html = imagesForTile(product, safe_product_title, tile_settings);
    const add_to_cart_alt = (tile_settings.is_simplified === true) ? '' : addToCartAltForTile(product);
    const quickview_html = (tile_settings.has_quickview) ? quickviewForTile() : '';
    const swatches_html = (tile_settings.has_swatches === false && tile_settings.has_quickview === false) ? '' : swatchesForTile(product, tile_settings);
    const ratings_html = (tile_settings.is_simplified === true) ? '' : ratingsForTile(product);
    const price_html = pricesForTile(product, product_available, tile_settings);
    const has_video = (product?.custom_fields['astr-product_includes_video'] === 'true') ?? false;
    const ab_video = (product?.custom_fields['astr-ab_test_video'] === 'true') ?? false;
    style += (typeof tile_settings.position !== 'undefined' && tile_settings.position !== '' && tile_settings.position !== null && tile_settings.position !== 'null') ? `order: ${tile_settings.position};` : '';
    style = (style !== '') ? ` style="${style}"` : '';

    // Used from collection-placeholder-tiles.liquid to set the tile order the same as the placeholder when marketing blocks are present
    const tile_id = (typeof tile_settings.tile_index !== 'undefined' && tile_settings.tile_index !== '') ? ` id="product-tile-${tile_settings.tile_index}"` : '';

    // Disable animations for the first 5 tiles to optimize performance
    if (typeof tile_settings.tile_index !== 'undefined' && tile_settings.tile_index <= 5 && tile_settings.tile_index !== '') {
      tile_settings.has_animations = false;
    }

    let video_status_html = '';
    if (has_video) {
      console.log(`[ASTR] Product has video: ${product_handle}`, has_video);
      video_status_html = `<div class="sr-only product-tile__video-status" aria-live="polite" data-video-status></div>`;
    }

    // Use case:
    // If we are on a non-plus size PLP, the product has both standard and plus size variants but all standard size variants are unavailable, no swatches will appear and the product will not be displayed.
    if (tile_settings.has_swatches === true && swatches_html === '') {
      return '';
    }

    return `<div class="product-tile${(tile_settings.is_slider === true) ? ' swiper-slide' : '' }${(tile_settings.is_lookbook === false && tile_settings.is_slider !== true) ? ' column-xs-6 column-sm-3' : '' }${tile_settings.has_animations !== false ? ' animate animate--fadeInUp ' : '' } ${(tile_settings.is_simplified === true && tile_settings.has_swatches === false && tile_settings.has_quickview === false) ? ' product-tile--simplified' : ''}${(has_video) ? ' has-video' : ''}"
        ${tile_id}
        data-product-url="${product_url}"
        data-product-handle="${product_handle}"
        data-product-id="${product.product_id}"
        data-product-available="${product_available}"
        data-first-variant-id="${product.skus[0].id}"
        data-empi="${product.skus[0].id}"
        data-product-tile
        data-quickview="${tile_settings.has_quickview}"
        data-plus-size="${has_plus_size}"
        ${(has_video) ? 'data-video-init="false" data-video-observer="false"' : ''}
        ${(ab_video) ? 'data-ab-video="true"' : ''}
        tabindex="0"
        ${style}
        aria-label="${safe_product_title}">
        ${video_status_html}
        ${wishlist_html}
        
        <div class="product-tile__image-container">
          <a class="product-tile__image" href="${product_url}" data-product-tile-image aria-label="${product.name}">
            ${images_html}
            ${add_to_cart_alt}
            ${flags_html}
          </a>
          ${quickview_html}
        </div>

        <div class="product-tile__bottom">
          ${(tile_settings.has_swatches === false && tile_settings.has_quickview === false) ? '' : '<div class="product-tile__colors-rating">' }
            ${swatches_html}
            ${ratings_html}
          ${(tile_settings.has_swatches === false && tile_settings.has_quickview === false) ? '' : '</div>' }

          ${featured_promos_html}

          <p class="product-tile__title" data-product-tile-title>
            <a href="${product_url}" data-product-tile-link><span>${product.name}</span></a>
          </p>

          <p class="product-tile__price price" data-product-tile-price>
            ${price_html}
          </p>

          ${promos_html}
        </div>
      </div>`;
  } catch (e) {
    console.error(e);
    console.error(product);
    return '';
  }
};
